/* eslint-disable no-param-reassign */
// @flow
import React, { Component } from 'react';
import Grid from '@mui/material/Unstable_Grid2';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { getGreeting } from 'utils/greetingMessage';
import { Container } from './Dashboard.style';
import { TotalRequest, ServerStatus } from './components';

type StateType = {
  time: number,
};
export type StatePropsType = {
  stats: any,
  userName: String,
};
export type DispatchPropsType = {
  fetchBillingDetailsRequest: Function,
};
declare type Props = StatePropsType & DispatchPropsType;

class Dashboard extends Component<Props & DispatchPropsType, StateType> {
  interval: IntervalID;

  constructor(props) {
    super(props);
    this.state = {
      time: Date.now(),
    };
  }

  componentDidMount() {
    this.fetchData();
    this.interval = setInterval(() => this.setState({}, this.fetchData), 20000);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  fetchData = () => {
    const { time } = this.state;
    if ((Date.now() - time) / (5 * 60 * 1000) > 1) {
      window.location.reload(false);
    }
    const { fetchBillingDetailsRequest } = this.props;
    fetchBillingDetailsRequest();
  };

  render() {
    const { stats, userName } = this.props;
    return (
      <Container>
        <Box sx={{ flexGrow: 1 }}>
          <Grid container>
            <Grid md={12} paddingLeft={1} paddingTop={1}>
              <Typography variant="subtitle1" color="text.primary" gutterBottom>
                {getGreeting()} <b>{userName}</b>, Welcome to TACS Dashboard
              </Typography>
            </Grid>
          </Grid>
        </Box>
        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={1}>
            <Grid spacing={1} md={12}>
              <Grid container item spacing={1} md={12}>
                <Grid md={4}>
                  <ServerStatus variant="info" link="/logs/vehicle/1" records={stats.totalVehicleInsideToday} title="Vehicles inside the mine" />
                </Grid>
                <Grid md={4}>
                  <ServerStatus
                    variant="secondary"
                    link="/logs/vehicle/2"
                    records={stats.totalVehicleEnteredToday}
                    duration="1d"
                    title="Vehicles entered today"
                  />
                </Grid>
                <Grid md={4}>
                  <ServerStatus
                    variant="error"
                    link="/logs/vehicle/3"
                    records={stats.totalVehicleExitedToday}
                    duration="1d"
                    title="Vehicles exited today"
                  />
                </Grid>
              </Grid>
              <Grid container item spacing={1} marginTop={2} md={12}>
                <Grid md={6}>
                  <TotalRequest
                    records={{
                      date: stats.timeSeries.dates,
                      data: stats.timeSeries.totalWeight,
                    }}
                    duration="1w"
                    title="Material Quantity (in MT)"
                    colorCode="#28a745"
                    yAxis={{
                      min: 0,
                      max: 150000,
                      stepSize: 15000,
                    }}
                  />
                </Grid>
                <Grid md={6}>
                  <TotalRequest
                    records={{
                      date: stats.timeSeries.dates,
                      data: stats.timeSeries.totalPrice,
                    }}
                    duration="1w"
                    title="Amount of Quantity Dispatched (in Rupee)"
                    colorCode="#d9534f"
                    yAxis={{
                      min: 0,
                      max: 40000000,
                      stepSize: 4000000,
                    }}
                  />
                </Grid>
              </Grid>
              <Grid container item spacing={1} md={12}>
                <Grid md={6}>
                  <ServerStatus
                    variant="warning"
                    link="/logs/vehicle/4"
                    records={stats.totalMaterialDispatchedToday}
                    duration="in MT"
                    title="Material dispatched today"
                  />
                </Grid>
                <Grid md={6}>
                  <ServerStatus
                    variant="success"
                    link="/logs/vehicle/5"
                    records={stats.totalMaterialPriceDispatchedToday}
                    duration="in Rupee"
                    title="Price of the material dispatched today"
                  />
                </Grid>
                <Grid md={6}>
                  <ServerStatus
                    variant="warning"
                    records={stats.totalMaterialDispatchedYesterday}
                    duration="in MT"
                    title="Material dispatched yesterday"
                  />
                </Grid>
                <Grid md={6}>
                  <ServerStatus
                    variant="success"
                    records={stats.totalMaterialPriceDispatchedYesterday}
                    duration="in Rupee"
                    title="Price of the material dispatched yesterday"
                  />
                </Grid>
                <Grid md={6}>
                  <ServerStatus
                    variant="warning"
                    records={stats.totalMaterialDispatchedCurrentMonth}
                    duration="in MT"
                    title="Material dispatched in current month"
                  />
                </Grid>
                <Grid md={6}>
                  <ServerStatus
                    variant="success"
                    records={stats.totalMaterialPriceDispatchedCurrentMonth}
                    duration="in Rupee"
                    title="Price of the material dispatched in current month"
                  />
                </Grid>
                <Grid md={6}>
                  <ServerStatus
                    variant="warning"
                    records={stats.totalMaterialDispatchedLastMonth}
                    duration="in MT"
                    title="Material dispatched in last month"
                  />
                </Grid>
                <Grid md={6}>
                  <ServerStatus
                    variant="success"
                    records={stats.totalMaterialPriceDispatchedLastMonth}
                    duration="in Rupee"
                    title="Price of the material dispatched in last month"
                  />
                </Grid>
                <Grid md={6}>
                  <ServerStatus
                    variant="warning"
                    records={stats.totalMaterialDispatchedCurrentYear}
                    duration="in MT"
                    title="Material dispatched in current financial year"
                  />
                </Grid>
                <Grid md={6}>
                  <ServerStatus
                    variant="success"
                    records={stats.totalMaterialPriceDispatchedCurrentYear}
                    duration="in Rupee"
                    title="Price of the material dispatched in current financial year"
                  />
                </Grid>
                <Grid md={6}>
                  <ServerStatus
                    variant="warning"
                    records={stats.totalMaterialDispatchedLastYear}
                    duration="in MT"
                    title="Material dispatched in last financial year"
                  />
                </Grid>
                <Grid md={6}>
                  <ServerStatus
                    variant="success"
                    records={stats.totalMaterialPriceDispatchedLastYear}
                    duration="in Rupee"
                    title="Price of the material dispatched in last financial year"
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </Container>
    );
  }
}

export default Dashboard;
